import React, { useRef, useState, useEffect } from "react";
// import axios from "axios";
// import config from "../../config";
import useAxios from "../../utils/useAxios"; // Import the custom Axios instance
import { Link } from "react-router-dom";
import Tagify from "@yaireo/tagify";
import "@yaireo/tagify/dist/tagify.css"; // Import Tagify CSS
import Select from "react-select";
import config from "../../config";

const Events = () => {
  const [events, setEvents] = useState([]);
  const [adsGroup, setAdsGroup] = useState([]);
  const [scripts, setScripts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [moderatorData, setModeratorData] = useState([]);
  const [wallLayoutSelectedId, setWallLayoutSelectedId] = useState(null);
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [modSelect, setSelectMod] = useState([]);

  const [formData, setFormData] = useState({
    // Event details
    password: "",
    event_name: "",
    event_location: "",
    event_date: "",
    event_start_time: "12:00 AM",
    length_of_event: "0.5",
    notification_status: "off",
    notification_emails: "",
    script_ids: [],
    ads_group_id: "",
    ads_per_post: 0,
    event_status: "Draft",
    password: "",

    event_url_slug: "",

    // Wall settings
    wall_speed: "Off",
    wall_layout: "4-Column Social Mosaic",

    // Branding details
    page_title: "",
    page_description: "",
    page_keywords: "",
    brand_custom_logo: null,
    brand_social_share_image: null,
    brand_watermark_image: null,
    brand_custom_logo_url: "",
    brand_social_share_image_url: "",
    brand_watermark_image_url: "",

    // Contact and legal settings
    contact_information: "off",
    legal: "off",
    copyright: "off",

    // Brand colors
    top_brand_color: "#000000",
    top_banner_text_color: "#FFFFFF",
    bottom_brand_color: "#000000",
    bottom_banner_text_color: "#FFFFFF",
    cta_button_color: "#000000",
    cta_button_text_color: "#FFFFFF",

    // New banner and CTA fields
    top_banner_text: "", // Top banner text
    bottom_banner_text: "", // Bottom banner text
    cta_text: "", // CTA button text
    cta_url: "", // CTA button URL
  });
  const [tagifyScriptsInstance, setTagifyScriptsInstance] = useState(null); // Store Tagify instance
  const inputScriptsTagRef = useRef(null); // Ref for the input field
  const axiosAPI = useAxios(); // Use the custom hook for Axios

  // Helper function to generate time slots with 15-minute intervals
  const generateTimeSlots = () => {
    const timeSlots = [];
    const periods = ["AM", "PM"];
    const totalHours = 24;

    for (let hour = 0; hour < totalHours; hour++) {
      for (let minutes = 0; minutes < 60; minutes += 15) {
        const period = hour < 12 ? "AM" : "PM";

        let displayHour = hour % 12;
        if (displayHour === 0) displayHour = 12;

        const minuteString =
          minutes === 0
            ? "00"
            : minutes === 15
            ? "15"
            : minutes === 30
            ? "30"
            : "45";

        const time = `${
          displayHour < 10 ? "0" + displayHour : displayHour
        }:${minuteString} ${period}`;

        timeSlots.push(time);
      }
    }

    return timeSlots;
  };

  const resetForm = () => {
    setFormData({
      id: "",
      password: "",
      // modSelect: [],
      event_name: "",
      event_location: "",
      event_date: "",
      event_start_time: "12:00 AM",
      length_of_event: "0.5",
      notification_status: "off",
      notification_emails: "",
      script_ids: [],
      ads_group_id: "",
      ads_per_post: 0,
      event_status: "Draft",
      event_url_slug: "",

      // Wall settings
      wall_speed: "Off",
      wall_layout: "4-Column Social Mosaic",

      // Branding details
      page_title: "",
      page_description: "",
      page_keywords: "",
      brand_custom_logo: null,
      brand_social_share_image: null,
      brand_watermark_image: null,
      brand_custom_logo_url: "",
      brand_social_share_image_url: "",
      brand_watermark_image_url: "",

      // Contact and legal settings
      contact_information: "off",
      legal: "off",
      copyright: "off",

      // Brand colors
      top_brand_color: "#000000",
      top_banner_text_color: "#FFFFFF",
      bottom_brand_color: "#000000",
      bottom_banner_text_color: "#FFFFFF",
      cta_button_color: "#000000",
      cta_button_text_color: "#FFFFFF",

      // New banner and CTA fields
      top_banner_text: "", // Top banner text
      bottom_banner_text: "", // Bottom banner text
      cta_text: "", // CTA button text
      cta_url: "", // CTA button URL
    });
  };

  // Function to handle input changes
  const handleChange = (e) => {
    // const { id, checked } = e.target;
    // console.log(id, checked);
    // console.log(e.target.id);
    // console.log(e.target.value);

    setFormData({ ...formData, [e.target.id]: e.target.value });
    // console.log({ formData });/
  };

  // Function to handle input changes
  const handleSwitchChange = (e) => {
    const { id, checked } = e.target;
    console.log(id, checked);

    // Update the state using the checkbox's checked value
    setFormData({ ...formData, [id]: checked ? "on" : "off" });
    console.log({ formData });
  };

  // Handle file selection
  const handleFileChange = (e) => {
    const { id, files } = e.target;
    const selectedFile = files[0];

    // Check if a file was selected and its type is a video
    if (selectedFile && selectedFile.type.startsWith("video/")) {
      // Show an error message if it's a video file
      window.notifyMessage("Error", "Only image files are allowed.", "danger");
      return; // Don't update formData if it's a video
    }

    // Update formData with the selected file
    setFormData({ ...formData, [id]: selectedFile });

    console.log({ formData });
  };

  // Function to fetch events data from the API
  const fetchEvents = async () => {
    try {
      const response = await axiosAPI.get(`/api/events/get-events`);
      const eventsData = response.data;

      setEvents(eventsData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching events:", error);
      setLoading(false);
    }
  };

  const fetchModerators = async () => {
    try {
      const res = await axiosAPI.get("/api/users/get-all-moderator");

      // console.log("API raw response:", res.data);

      const moderators = res.data.data; //  correct array
      if (!Array.isArray(moderators)) throw new Error("Expected an array");

      const formatted = moderators.map((mod) => ({
        value: mod.id,
        // label: `${mod.email} - ${mod.phone_number}`,
        label: `${mod.email || "No Email"} - ${
          mod.phone_number || "No Phone Number"
        } `,
      }));

      // console.log("Formatted:", formatted);
      setOptions(formatted);
    } catch (err) {
      console.error("Failed to load moderators:", err);
    }
  };

  // console.log("Formatted:", options);

  const handleModChange = (selectedOptions) => {
    console.log("Select option is", selectedOptions);
    const selectedIds = selectedOptions.map((option) => option.value); // [2, 3, 4, 5]

    console.log("Selected Ids", selectedIds);
    const commaSeparated = selectedIds.join(","); // "2,3,4,5"

    // setFormData((prev) => ({
    //   ...prev,
    //   modSelect: commaSeparated, // string instead of array
    // }));

    setSelectMod(commaSeparated);
    setSelected(selectedOptions); // for display
  };

  // Fetch scripts from the server
  const fetchScripts = async (fields = "") => {
    try {
      const response = await axiosAPI.get(`/api/scripts/get-scripts`, {
        params: { fields: fields },
      });
      setScripts(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching scripts:", error);
      setLoading(false);
    }
  };

  // Function to fetch adsGroup data from the API
  const fetchEventAdsGroups = async () => {
    try {
      const response = await axiosAPI.get(
        `/api/ads-group/get-event-ads-groups`
      );
      const adsData = response.data;

      setAdsGroup(adsData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching adsGroup:", error);
      setLoading(false);
    }
  };

  // Fetch events, scripts and adsGroup when component mounts
  useEffect(() => {
    fetchEvents();
    fetchScripts("id,script_name");
    fetchEventAdsGroups();
    fetchModerators();
  }, []);

  // Scripts - TAGIFY - START

  // Function to set default tags
  const setDefaultTags = (script_ids) => {
    const defaultTags = scripts
      .filter((script) => script_ids.includes(script.id))
      .map((script) => script.script_name); // Map IDs to ad_names

    if (inputScriptsTagRef.current) {
      tagifyScriptsInstance.removeAllTags(); // Remove any existing tags (optional)
      tagifyScriptsInstance.addTags(defaultTags); // Add the new tags
    }
  };

  // Update formData on add/remove tag
  const updateFormDataForAds = (script_name, action) => {
    const matchingItem = scripts.find(
      (item) => item.script_name === script_name
    );
    const matchingItemId = matchingItem ? matchingItem.id : null;

    console.log({ matchingItemId });

    if (matchingItemId) {
      setFormData((prevFormData) => {
        const updatedScriptIds =
          action === "add"
            ? [...prevFormData.script_ids, matchingItemId]
            : prevFormData.script_ids.filter((id) => id !== matchingItemId);

        return {
          ...prevFormData,
          script_ids: updatedScriptIds,
        };
      });
    }
  };

  useEffect(() => {
    if (inputScriptsTagRef.current) {
      const tagify = new Tagify(inputScriptsTagRef.current, {
        whitelist: scripts.map((item) => item.script_name), // Use script_name as the tag value
        enforceWhitelist: true, // Only allow tags from the whitelist
        dropdown: {
          enabled: 0, // Show all suggestions on focus
          searchKeys: ["script_name"], // Keys to search in whitelist objects
          mode: "all", // Ensure the dropdown mode is set
        },
      });

      // Store the Tagify instance to later manipulate
      setTagifyScriptsInstance(tagify);

      tagify.on("add", (e) => updateFormDataForAds(e.detail.data.value, "add"));
      tagify.on("remove", (e) =>
        updateFormDataForAds(e.detail.data.value, "remove")
      );

      return () => {
        tagify.destroy(); // Cleanup to prevent memory leaks
      };
    }
  }, [scripts]);

  console.log({ modSelect });

  // Scripts - TAGIFY - END

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true); // Set isSubmitting to true when form starts submitting

    console.log("Data is", formData);

    // return

    // Check if essential form fields are not empty
    if (!formData.event_name) {
      window.notifyMessage("Error", "Event Name is mandatory.", "danger");
      setIsSubmitting(false);
      return; // Stop the form submission if event name is missing
    }

    if (!formData.event_date) {
      window.notifyMessage("Error", "Event Date is mandatory.", "danger");
      setIsSubmitting(false);
      return; // Stop the form submission if event date is missing
    }

    if (!formData.event_url_slug) {
      window.notifyMessage("Error", "Event URL slug is mandatory.", "danger");
      setIsSubmitting(false);
      return; // Stop the form submission if event date is missing
    }

    try {
      // Create a FormData instance to handle file uploads and other form fields
      const formDataToSubmit = new FormData();

      // Loop through the formData object and append each field to FormData
      Object.entries(formData).forEach(([key, value]) => {
        if (value instanceof File) {
          // If the value is a file, append it as a file field
          formDataToSubmit.append(key, value);
        } else if (value !== null && value !== undefined) {
          // If it's a regular field (not null or undefined), append it as a string
          formDataToSubmit.append(key, value);
        }
      });

      formDataToSubmit.append("moderator_ids", modSelect);

      // return

      // Check if it's an existing event (editing)
      const requestUrl = formData.id
        ? `/api/events/update-event/${formData.id}` // Edit existing event
        : `/api/events/add-event`; // Add new event

      // Set the correct HTTP method (POST for adding, PUT for editing)
      const httpMethod = formData.id ? "PUT" : "POST";

      // Make the API call to add or edit the event
      const response = await axiosAPI({
        method: httpMethod,
        url: requestUrl,
        data: formDataToSubmit,
        headers: {
          "Content-Type": "multipart/form-data", // Set the correct content type for file uploads
        },
      });

      // Notify event on successful event addition
      window.notifyMessage(
        "Success",
        "Successfully added the event!",
        "success"
      );

      setIsSubmitting(false);

      // Call resetForm to reset all the form fields
      resetForm();

      hideModal("newEventModal");

      // Reload the events data (optional, depending on your app)
      fetchEvents();
    } catch (error) {
      // Check if it's an error from the API response
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage(
          "Error",
          error.response.data.message, // Display specific error message from backend
          "danger"
        );
        setIsSubmitting(false);
      } else {
        // Handle generic errors (e.g., network errors)
        window.notifyMessage("Error", "There was an error!", "danger");
        setIsSubmitting(false);
      }
    }
  };

  // useEffect(() => {
  //   console.log({ formData });
  // }, [formData]);

  const openAddModal = () => {
    // reset form
    resetForm();

    generateHash();

    // Optionally, you can open the modal programmatically here if you're using Bootstrap modals
    showModal("newEventModal");
  };

  const openEditModal = (eventId) => {
    const eventToEdit = events.find((event) => event.id === eventId);

    const existingModIds = eventToEdit?.moderators_ids?.split(",").map(Number); // [2,3,4]

    // Match these IDs with available options to show as selected
    const preselected = options.filter((opt) =>
      existingModIds?.includes(opt.value)
    );

    console.log("Preselected", preselected);

    setSelected(preselected); //  React Select will now show them preselected

    setFormData((prev) => ({
      ...prev,
      moderators_ids: preselected, // string instead of array
    }));

    if (eventToEdit) {
      // Set formData with the details of the selected event
      setFormData({
        id: eventToEdit.id, // Set the event ID
        event_name: eventToEdit.event_name || "", // Set the event name
        event_location: eventToEdit.event_location || "", // Set the event location
        // event_date: eventToEdit.event_date || "", // Set the event date
        event_date: eventToEdit.event_date
          ? new Date(eventToEdit.event_date).toISOString().split("T")[0]
          : "",
        event_start_time: eventToEdit.event_start_time || "12:00 AM", // Set the event start time
        length_of_event: eventToEdit.length_of_event || "0.5", // Set the length of event
        notification_status: eventToEdit.notification_status || "off", // Set notification status
        notification_emails: eventToEdit.notification_emails || "", // Set notification emails
        script_ids: [], // Set script ids
        ads_group_id: eventToEdit.ads_group_id || "", // Set ads_group_id
        ads_per_post: eventToEdit.ads_per_post || 0, // Set ads_per_post
        event_status: eventToEdit.event_status || "Draft", // Set event status
        event_url_slug: eventToEdit.event_url_slug || "", // Set event URL slug

        // Wall settings (handle null or undefined)
        wall_speed: eventToEdit.wall_speed || "Off", // Set wall speed
        wall_layout: eventToEdit.wall_layout || "4-Column Social Mosaic", // Set wall layout

        // Branding details
        page_title: eventToEdit.page_title || "", // Set brand title
        page_description: eventToEdit.page_description || "", // Set brand description
        page_keywords: eventToEdit.page_keywords || "", // Set brand keywords
        brand_custom_logo: eventToEdit.brand_custom_logo || null, // Set custom logo (could be null)
        brand_social_share_image: eventToEdit.brand_social_share_image || null, // Set social share image
        brand_watermark_image: eventToEdit.brand_watermark_image || null, // Set watermark image
        brand_custom_logo_url: eventToEdit.brand_custom_logo_url || "",
        brand_social_share_image_url:
          eventToEdit.brand_social_share_image_url || "",
        brand_watermark_image_url: eventToEdit.brand_watermark_image_url || "",

        // Contact and legal settings
        contact_information: eventToEdit.contact_information || "off", // Set contact information
        legal: eventToEdit.legal || "off", // Set legal
        copyright: eventToEdit.copyright || "off", // Set copyright

        // Brand colors (set to default if not found in event)
        top_brand_color: eventToEdit.top_brand_color || "#000000",
        top_banner_text_color: eventToEdit.top_banner_text_color || "#FFFFFF",
        bottom_brand_color: eventToEdit.bottom_brand_color || "#000000",
        bottom_banner_text_color:
          eventToEdit.bottom_banner_text_color || "#FFFFFF",
        cta_button_color: eventToEdit.cta_button_color || "#000000",
        cta_button_text_color: eventToEdit.cta_button_text_color || "#FFFFFF",

        // New fields (top banner, bottom banner, CTA)
        top_banner_text: eventToEdit.top_banner_text || "", // Set top banner text
        bottom_banner_text: eventToEdit.bottom_banner_text || "", // Set bottom banner text
        cta_text: eventToEdit.cta_text || "", // Set CTA button text
        cta_url: eventToEdit.cta_url || "", // Set CTA button URL

        // Reset password field, as it needs to be set again by the user
        password: "",
      });

      const defaultWallLayout = wall_layouts.find(
        (layout) => layout.title === eventToEdit.wall_layout
      );
      if (defaultWallLayout) {
        setWallLayoutSelectedId(defaultWallLayout.id);
      }

      const script_ids_edit = eventToEdit.script_ids;
      console.log({ script_ids_edit });

      setDefaultTags(script_ids_edit);

      const moderators_ids_edit = eventToEdit.moderators_ids;

      setSelectMod(moderators_ids_edit);

      // Optionally, you can open the modal programmatically here if you're using Bootstrap modals
      showModal("newEventModal");
    }
  };

  const handleDelete = async (eventId) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      await axiosAPI.delete(`/api/events/delete-event/${eventId}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchEvents();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  const generateHashFromTime = async () => {
    const timestamp = Date.now().toString();
    const encoder = new TextEncoder();
    const data = encoder.encode(timestamp);

    try {
      const hashBuffer = await crypto.subtle.digest("SHA-256", data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");

      const filteredHash = hashHex.replace(/[0-9]/g, "").substring(0, 16);
      return filteredHash;
    } catch (error) {
      console.error("Hash generation failed", error);
      return "";
    }
  };

  const generateHash = async () => {
    const hashCode = await generateHashFromTime();
    console.log({ hashCode });
    setFormData((prevFormData) => ({
      ...prevFormData,
      event_url_slug: hashCode,
    }));
  };

  function showModal(id) {
    const modal_el = document.querySelector("#" + id);
    let modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      modal_obj = new window.bootstrap.Modal(modal_el, {
        backdrop: "static",
      });
    }

    modal_obj.show();
  }

  function hideModal(id) {
    const modal_el = document.querySelector("#" + id);
    const modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      return;
    }

    modal_obj.hide();
  }

  const wall_layouts = [
    {
      id: 1,
      title: "4-Column Social Mosaic",
      image: "../../icon/Social Wall Layout_4Column.png",
    },
    {
      id: 2,
      title: "2-Column Social Mosaic",
      image: "../../icon/Social Wall Layout_2Column.png",
    },
    {
      id: 3,
      title: "Single Column List View",
      image: "../../icon/Social Wall Layout_1Column.png",
    },
    {
      id: 4,
      title: "Single Post Spotlight",
      image: "../../icon/Social Wall Layout_SinglePost.png",
    },
  ];

  useEffect(() => {
    const defaultWallLayout = wall_layouts.find(
      (layout) => layout.title === formData.wall_layout
    );
    if (defaultWallLayout) {
      setWallLayoutSelectedId(defaultWallLayout.id);
    }
  }, []);

  const handleWallLayoutImageClick = (id) => {
    const selectedLayout = wall_layouts.find((layout) => layout.id === id);
    setFormData((prevData) => ({
      ...prevData,
      wall_layout: selectedLayout.title,
    }));

    setWallLayoutSelectedId(id);
  };

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div className="d-flex"></div>
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openAddModal()}
            >
              Add New Event
            </button>
          </div>
        </div>

        <div
          className="modal fade"
          id="newEventModal"
          tabIndex="-1"
          aria-labelledby="newEventModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-fullscreen">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title" id="newEventModalLabel">
                  {formData.id ? "Edit Event" : "Add New Event"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body bg-light">
                <form onSubmit={handleSubmit}>
                  <div className="card">
                    <div className="card-body">
                      {/* About the Event Section */}
                      <h5>
                        <b>About The Event</b>
                      </h5>
                      <div className="row mt-3">
                        {/* Event Name */}
                        <div className="col-md-6 mb-3">
                          <label htmlFor="event_name" className="form-label">
                            Event Name *
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="event_name"
                            value={formData.event_name}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        {/* Event Location */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="event_location"
                            className="form-label"
                          >
                            Event Location
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="event_location"
                            value={formData.event_location}
                            onChange={handleChange}
                          />
                        </div>

                        {/* Event Date */}
                        <div className="col-md-6 mb-3">
                          <label htmlFor="event_date" className="form-label">
                            Event Date *
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="event_date"
                            value={formData.event_date}
                            onChange={handleChange}
                          />
                        </div>

                        {/* Start Time (Updated to Dropdown) */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="event_start_time"
                            className="form-label"
                          >
                            Start Time
                          </label>
                          <select
                            className="form-select"
                            id="event_start_time"
                            value={formData.event_start_time}
                            onChange={handleChange}
                          >
                            {generateTimeSlots().map((time, index) => (
                              <option key={index} value={time}>
                                {time}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Length of Event (Updated to Dropdown with 0.5-hour increments) */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="length_of_event"
                            className="form-label"
                          >
                            Length of Event
                          </label>
                          <select
                            className="form-select"
                            id="length_of_event"
                            value={formData.length_of_event}
                            onChange={handleChange}
                          >
                            {Array.from({ length: 48 }, (_, index) => {
                              const value = (index + 1) / 2; // Generate 0.5, 1, 1.5, ..., 24
                              return (
                                <option key={index} value={value}>
                                  {`${value} Hour${value > 1 ? "s" : ""}`}
                                </option>
                              );
                            })}
                          </select>
                        </div>

                        {/* Notifications */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="notification_emails"
                            className="form-label"
                          >
                            Send Notifications
                          </label>

                          <input
                            type="text"
                            className="form-control"
                            id="notification_emails"
                            placeholder="Enter emails (comma-separated)"
                            value={formData.notification_emails}
                            onChange={handleChange}
                          />
                        </div>

                        {/* Notifications Status*/}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="notification_status"
                            className="form-label"
                          >
                            Notification Status
                          </label>

                          <select
                            className="form-select"
                            id="notification_status"
                            value={formData.notification_status}
                            onChange={handleChange}
                          >
                            <option value="on">ON</option>
                            <option value="off">OFF</option>
                          </select>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="event_url_slug"
                            className="form-label"
                          >
                            {" "}
                            Event URL *{" "}
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              id="add_url_slug_id"
                            >
                              <i className="fas fa-link"></i>
                            </span>
                            <select
                              className="form-select"
                              name="domain_id"
                              id="basic-addon3"
                            >
                              <option value=" https://www.bigscreensocial.app/">
                                {" "}
                                bigscreensocial.app
                              </option>
                            </select>

                            <input
                              type="text"
                              className="form-control"
                              id="event_url_slug"
                              value={formData.event_url_slug}
                              onChange={handleChange}
                              aria-describedby="basic-addon3"
                              maxLength="80"
                              autoComplete="off"
                              placeholder="URL"
                            />
                          </div>
                          <div
                            className="invalid-feedback"
                            id="url_checker_invalid_message_add"
                          >
                            URL is not Available!
                          </div>
                          <div
                            className="valid-feedback"
                            id="url_checker_valid_message_add"
                          >
                            URL is Available!
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label htmlFor="event_status" className="form-label">
                            Event Status
                          </label>
                          <select
                            className="form-select"
                            id="event_status"
                            value={formData.event_status}
                            onChange={handleChange}
                          >
                            <option value="Draft">Draft</option>
                            <option value="Live">Live</option>
                            <option value="Private">Private</option>
                            <option value="Archive">Archive</option>
                          </select>
                        </div>

                        {/* Script Ids */}
                        <div className="col-md-6 mb-3">
                          <label htmlFor="script_ids" className="form-label">
                            Scripts
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="script_ids"
                            placeholder="Enter script id's"
                            ref={inputScriptsTagRef}
                          />
                        </div>

                        {/* ads_group_id */}
                        <div className="col-md-6 mb-3">
                          <label htmlFor="ads_group_id" className="form-label">
                            Ads Program
                          </label>
                          <select
                            className="form-select"
                            id="ads_group_id"
                            value={formData.ads_group_id}
                            onChange={handleChange}
                          >
                            <option key="select-ads_group_id" value="">
                              Select
                            </option>
                            {adsGroup.map((adsGroupItem) => (
                              <option
                                key={adsGroupItem.id}
                                value={adsGroupItem.id}
                              >
                                {adsGroupItem.ads_group_name}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* ads_per_post */}
                        <div className="col-md-6 mb-3">
                          <label htmlFor="ads_per_post" className="form-label">
                            Ads per Post
                          </label>
                          <select
                            className="form-select"
                            id="ads_per_post"
                            value={formData.ads_per_post}
                            onChange={handleChange}
                          >
                            {/* Generate options from 1 to 20 */}
                            {Array.from({ length: 21 }, (_, index) => (
                              <option key={index} value={index}>
                                {index}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Password Field */}
                        <div className="col-md-6 mb-3">
                          <label htmlFor="password" className="form-label">
                            Password (optional)
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            id="password"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="Enter password (optional)"
                          />
                        </div>

                        {/* Password Field */}
                        <div className="col-md-6 mb-3">
                          <label htmlFor="password" className="form-label">
                            Moderator (List)
                          </label>
                          <Select
                            isMulti
                            options={options}
                            value={selected}
                            onMenuOpen={() => {
                              console.log("Dropdown opened!");
                            }}
                            onChange={handleModChange}
                            placeholder="Choose moderators..."
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Event Settings */}
                  <div className="card">
                    <div className="card-body">
                      <h5>
                        <b>Event Settings</b>
                      </h5>
                      <div className="row mt-3">
                        {/* Wall Speed */}
                        <div className="col-md-12 mb-3">
                          <label htmlFor="wall_speed" className="form-label">
                            Wall Speed
                          </label>
                          <select
                            className="form-select"
                            id="wall_speed"
                            value={formData.wall_speed}
                            onChange={handleChange}
                          >
                            <option>Off</option>
                            <option>Very Slow</option>
                            <option>Slow</option>
                            <option>Normal</option>
                            <option>Fast</option>
                            <option>Very Fast</option>
                          </select>
                        </div>

                        {/* Wall Layout */}
                        <div className="col-md-6 mb-3 d-none">
                          <h5 htmlFor="wall_layout" className="form-label">
                            Choose Wall Layout
                          </h5>
                          <select
                            className="form-select"
                            id="wall_layout"
                            value={formData.wall_layout}
                            onChange={handleChange}
                          >
                            <option>4-Column Social Mosaic</option>
                            <option>2-Column Social Mosaic</option>
                            <option>Single Column List View</option>
                            <option>Single Post Spotlight</option>
                          </select>
                        </div>

                        <div className="col-md-12 mb-3">
                          <h3 className="text-dark mb-3">Choose Wall Layout</h3>
                          <p className="text-muted">
                            Select a visual layout for your posts.
                          </p>
                          <div className="row">
                            {wall_layouts.map((layout) => (
                              <div className="col-md-3 mb-4" key={layout.id}>
                                <div className="text-center">
                                  <img
                                    src={layout.image}
                                    alt={layout.title}
                                    className={`img-fluid mb-2 border-1 text-center ${
                                      wallLayoutSelectedId === layout.id
                                        ? "border-primary"
                                        : ""
                                    }`}
                                    style={{
                                      border:
                                        wallLayoutSelectedId === layout.id
                                          ? "3px solid blue"
                                          : "",
                                      borderRadius: "8px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      handleWallLayoutImageClick(layout.id)
                                    }
                                  />
                                  <h6 className="text-dark">{layout.title}</h6>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Branding */}
                  <div className="card">
                    <div className="card-body">
                      <h5>
                        <b>Branding</b>
                      </h5>
                      <div className="row mt-3">
                        {/* Page Title */}
                        <div className="col-md-6 mb-3">
                          <label htmlFor="page_title" className="form-label">
                            Page Title
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="page_title"
                            value={formData.page_title}
                            onChange={handleChange}
                          />
                        </div>

                        {/* Page keywords */}
                        <div className="col-md-6 mb-3">
                          <label htmlFor="page_keywords" className="form-label">
                            Page keywords
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="page_keywords"
                            value={formData.page_keywords}
                            onChange={handleChange}
                          />
                        </div>

                        {/* Page Description */}
                        <div className="col-md-12 mb-3">
                          <label
                            htmlFor="page_description"
                            className="form-label"
                          >
                            Page Description
                          </label>
                          <textarea
                            className="form-control"
                            id="page_description"
                            rows="5"
                            value={formData.page_description}
                            onChange={handleChange}
                          ></textarea>
                        </div>

                        {/* Custom Logo File Upload */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="brand_custom_logo"
                            className="form-label"
                          >
                            Custom Logo
                            {formData.brand_custom_logo_url ? (
                              <Link
                                to={formData.brand_custom_logo_url}
                                target="_blank"
                                className="logo ms-2"
                              >
                                <button
                                  type="button"
                                  className="btn btn-icon btn-dark btn-sm me-2"
                                >
                                  <i className="fas fa-images"></i>
                                </button>
                              </Link>
                            ) : (
                              ""
                            )}
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="brand_custom_logo"
                            accept="image/*" // This will allow only image files
                            onChange={handleFileChange}
                          />
                        </div>

                        {/* Social Share Image File Upload */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="brand_social_share_image"
                            className="form-label"
                          >
                            Social Share Image
                            {formData.brand_social_share_image_url ? (
                              <Link
                                to={formData.brand_social_share_image_url}
                                target="_blank"
                                className="logo ms-2"
                              >
                                <button
                                  type="button"
                                  className="btn btn-icon btn-dark btn-sm me-2"
                                >
                                  <i className="fas fa-images"></i>
                                </button>
                              </Link>
                            ) : (
                              ""
                            )}
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="brand_social_share_image"
                            accept="image/*" // This will allow only image files
                            onChange={handleFileChange}
                          />
                        </div>

                        {/* Watermark File Upload */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="brand_watermark_image"
                            className="form-label"
                          >
                            Image Watermark
                            {formData.brand_watermark_image_url ? (
                              <Link
                                to={formData.brand_watermark_image_url}
                                target="_blank"
                                className="logo ms-2"
                              >
                                <button
                                  type="button"
                                  className="btn btn-icon btn-dark btn-sm me-2"
                                >
                                  <i className="fas fa-images"></i>
                                </button>
                              </Link>
                            ) : (
                              ""
                            )}
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="brand_watermark_image"
                            accept="image/*" // This will allow only image files
                            onChange={handleFileChange}
                          />
                        </div>
                      </div>

                      <div className="row mt-3">
                        {/* Contact Information Toggle */}
                        <div className="col-md-4 mb-3">
                          <label
                            htmlFor="contact_information"
                            className="form-label"
                          >
                            Contact Information
                          </label>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="contact_information"
                              value={formData.contact_information}
                              checked={formData.contact_information === "on"}
                              onChange={handleSwitchChange}
                            />
                          </div>
                        </div>

                        {/* Legal Toggle */}
                        <div className="col-md-4 mb-3">
                          <label htmlFor="legal" className="form-label">
                            Legal
                          </label>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="legal"
                              value={formData.legal}
                              checked={formData.legal === "on"}
                              onChange={handleSwitchChange}
                            />
                          </div>
                        </div>

                        {/* Copyright Toggle */}
                        <div className="col-md-4 mb-3">
                          <label htmlFor="copyright" className="form-label">
                            Copyright
                          </label>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="copyright"
                              value={formData.copyright}
                              checked={formData.copyright === "on"}
                              onChange={handleSwitchChange}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Color Pickers for Branding Colors */}

                      <div className="row mt-3">
                        {/* Top Brand Color */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="top_brand_color"
                            className="form-label"
                          >
                            Top Banner Brand Color
                          </label>
                          <input
                            type="color"
                            className="form-control form-control-color custom-color-input"
                            id="top_brand_color"
                            value={formData.top_brand_color}
                            onChange={handleChange}
                          />
                        </div>

                        {/* Top Banner Text Color */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="top_banner_text_color"
                            className="form-label"
                          >
                            Top Banner Text Color
                          </label>
                          <input
                            type="color"
                            className="form-control form-control-color custom-color-input"
                            id="top_banner_text_color"
                            value={formData.top_banner_text_color}
                            onChange={handleChange}
                          />
                        </div>

                        {/* Bottom Brand Color */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="bottom_brand_color"
                            className="form-label"
                          >
                            Bottom Banner Brand Color
                          </label>
                          <input
                            type="color"
                            className="form-control form-control-color custom-color-input"
                            id="bottom_brand_color"
                            value={formData.bottom_brand_color}
                            onChange={handleChange}
                          />
                        </div>

                        {/* Bottom Banner Text Color */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="bottom_banner_text_color"
                            className="form-label"
                          >
                            Bottom Banner Text Color
                          </label>
                          <input
                            type="color"
                            className="form-control form-control-color custom-color-input"
                            id="bottom_banner_text_color"
                            value={formData.bottom_banner_text_color}
                            onChange={handleChange}
                          />
                        </div>

                        {/* CTA Button Color */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="cta_button_color"
                            className="form-label"
                          >
                            CTA Button Color
                          </label>
                          <input
                            type="color"
                            className="form-control form-control-color custom-color-input"
                            id="cta_button_color"
                            value={formData.cta_button_color}
                            onChange={handleChange}
                          />
                        </div>

                        {/* CTA Button Text Color */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="cta_button_text_color"
                            className="form-label"
                          >
                            CTA Button Text Color
                          </label>
                          <input
                            type="color"
                            className="form-control form-control-color custom-color-input"
                            id="cta_button_text_color"
                            value={formData.cta_button_text_color}
                            onChange={handleChange}
                          />
                        </div>

                        {/* New Fields for Top Banner Text, Bottom Banner Text, CTA Text and URL */}
                        <div className="row mt-3">
                          {/* Top Banner Text */}
                          <div className="col-md-6 mb-3">
                            <label
                              htmlFor="top_banner_text"
                              className="form-label"
                            >
                              Top Banner Text
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="top_banner_text"
                              value={formData.top_banner_text}
                              onChange={handleChange}
                            />
                          </div>

                          {/* Bottom Banner Text */}
                          <div className="col-md-6 mb-3">
                            <label
                              htmlFor="bottom_banner_text"
                              className="form-label"
                            >
                              Bottom Banner Text
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="bottom_banner_text"
                              value={formData.bottom_banner_text}
                              onChange={handleChange}
                            />
                          </div>

                          {/* CTA Button Text */}
                          <div className="col-md-6 mb-3">
                            <label htmlFor="cta_text" className="form-label">
                              CTA Button Text
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="cta_text"
                              value={formData.cta_text}
                              onChange={handleChange}
                            />
                          </div>

                          {/* CTA Button URL */}
                          <div className="col-md-6 mb-3">
                            <label htmlFor="cta_url" className="form-label">
                              CTA Button URL
                            </label>
                            <input
                              type="url"
                              className="form-control"
                              id="cta_url"
                              value={formData.cta_url}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-success mt-3"
                    disabled={isSubmitting} // Disable the button while submitting
                  >
                    {isSubmitting ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      "Save Event"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <div className="d-flex justify-content-between">
                  <div>
                    <h4 className="card-title">
                      All Events (<span>{events.length}</span>)
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="display table table-striped table-hover basic-datatables">
                    <thead>
                      <tr>
                        <th>Event</th>
                        <th>Event Date</th>
                        <th>Start Time</th>
                        <th>Length</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : (
                        events.map((event) => {
                          // Format the event_date field
                          const formattedEventDate = new Date(
                            event.event_date
                          ).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          });

                          return (
                            <tr key={event.id}>
                              <td>{event.event_name}</td>{" "}
                              {/* Display the event name */}
                              <td>{formattedEventDate}</td>{" "}
                              {/* Display formatted event date */}
                              <td>{event.event_start_time}</td>{" "}
                              {/* Display event start time */}
                              <td>
                                {event.length_of_event
                                  ? event.length_of_event + " Hours"
                                  : ""}
                              </td>{" "}
                              {/* Display the length of the event */}
                              <td>
                                <button
                                  className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                  onClick={() => openEditModal(event.id)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                  onClick={() => handleDelete(event.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                                <Link
                                  // to={`${window.location.origin}/event/${event.event_url_slug}`}
                                  to={`${config.apiBaseUrl}/event/${event.event_url_slug}`}
                                  className="logo"
                                  target="_blank"
                                >
                                  <button className="btn btn-icon btn-round btn-dark btn-sm me-2">
                                    <i className="fas fa-link"></i>
                                  </button>
                                </Link>
                                <Link
                                  to={`${window.location.origin}/event-form/${event.event_url_slug}`}
                                  className="logo"
                                  target="_blank"
                                >
                                  <button className="btn btn-icon btn-round btn-dark btn-sm me-2">
                                    <i className="fas fa-file-alt"></i>
                                  </button>
                                </Link>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Events;
